import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface Announcement {
  id: string;
  is_active: boolean;
  message: string;
  font_size: string;
  font_family: string;
  background_color: string;
  text_color: string;
}

const MarqueeBanner = () => {
  const [announcement, setAnnouncement] = useState<Announcement | null>(null);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      const { data, error } = await supabase
        .from("site_announcements" as any)
        .select("*")
        .eq("is_active", true)
        .limit(1);

      if (!error && data && data.length > 0) {
        setAnnouncement(data[0] as any);
      }
    };

    fetchAnnouncement();
  }, []);

  if (!announcement || !announcement.message) return null;

  const fontFamilyMap: Record<string, string> = {
    "sans-serif": "ui-sans-serif, system-ui, sans-serif",
    "serif": "ui-serif, Georgia, serif",
    "monospace": "ui-monospace, SFMono-Regular, monospace",
  };

  return (
    <div
      className="w-full overflow-hidden relative z-20"
      style={{
        backgroundColor: announcement.background_color,
        color: announcement.text_color,
        fontSize: announcement.font_size,
        fontFamily: fontFamilyMap[announcement.font_family] || announcement.font_family,
      }}
    >
      <div className="marquee-track py-2.5">
        <span className="marquee-content inline-block whitespace-nowrap px-8">
          {announcement.message}
        </span>
        <span className="marquee-content inline-block whitespace-nowrap px-8" aria-hidden="true">
          {announcement.message}
        </span>
      </div>

      <style>{`
        .marquee-track {
          display: flex;
          width: max-content;
          animation: marquee-scroll 20s linear infinite;
        }
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};

export default MarqueeBanner;
